import { FormControl, FormLabel, Input } from "@chakra-ui/react";
import React from "react";

const SuggestedRowForm = ({ label, row, setRow }) => {
  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <Input
        value={row}
        onChange={(e) => setRow(e.target.value)}
        type="number"
        htmlSize={5}
        w="120px"
        placeholder="row number"
      />
    </FormControl>
  );
};

export default SuggestedRowForm;
